import i18n from '@/shared/i18n';

/**
 * Known internal agent tool display names → constant description i18n keys.
 *
 * Shared by Quill chat and the exception-resolution chat (useRunChat) so both
 * agent experiences label the same internal tools identically. The strings live
 * in the `automation` namespace (automation.json) where they originated.
 */
export const INTERNAL_TOOL_DESCRIPTION_KEYS: Readonly<Record<string, string>> =
  {
    bash: 'automation.quillChat.tool.internal.bash',
    edit: 'automation.quillChat.tool.internal.edit',
    glob: 'automation.quillChat.tool.internal.glob',
    grep: 'automation.quillChat.tool.internal.grep',
    ls: 'automation.quillChat.tool.internal.ls',
    multiedit: 'automation.quillChat.tool.internal.edit',
    read: 'automation.quillChat.tool.internal.read',
    write: 'automation.quillChat.tool.internal.write',
  };

/**
 * Resolves a static user-facing description for an internal Claude tool.
 *
 * @param displayName - ToolCallRequest display name
 * @returns Static translated description when the tool is internal, else ''
 */
export function getInternalToolCallDescription(displayName?: string): string {
  if (!displayName) {
    return '';
  }

  const key = INTERNAL_TOOL_DESCRIPTION_KEYS[displayName.toLowerCase()];
  return key ? i18n.t(key, { ns: 'automation' }) : '';
}
